import * as views from "../views";
import { i18nFormat } from "@/i18n.js";
// import RouterView from "@/core/components/RouteContainer.vue";
/**
 *
 * @param {Boolean} visible
 * @param {Boolean} search
 * @param {String} title
 * @param {String} domain
 */
let meta = (
  visible = true,
  breadcrumb = null,
  title = i18nFormat("t", "integration.title"),
  subtitle = i18nFormat("t", "integration.subtitle"),
  domain = null
) => ({
  headerVisible: visible,
  headerDescription: subtitle,
  headerTitle: title,
  headerDomain: domain,
  allowAutoSidebar: false,
  breadcrums: breadcrumb
});

export default [{
  path: "integrations",
  component: views.Layout,
  meta: meta(),
  children: [{
      path: "",
      name: "Integrations",
      component: views.Default,
      meta: meta(false)
    },
    // {
    //   path: "app/:app",
    //   name: "AppDetails",
    //   component: views.Default,
    //   meta: meta(true, false, [
    //     { name: i18n.t("generals.tutorials"), to: "Tutorials" },
    //     { name: i18n.t("generals.topics") }
    //   ])
    // }
  ]
}];
